import { createSelector } from '@reduxjs/toolkit';

const selectProjectPermissionsState = (state) => state.projectPermissions;

export const selectUserAdminPermissions = createSelector(
  [selectProjectPermissionsState],
  (state) => state.userAdminPermissions
);

export const selectUserAdminBusinessIds = createSelector(
  [selectUserAdminPermissions],
  (adminPermissions) => Object.keys(adminPermissions)
);
